/**
 * กฎ auth ที่ใช้ร่วมกันทั้งแอป
 *
 * `MIN_PASSWORD_LENGTH` เคยถูก hardcode ไว้ 3 จุดใน Signup.tsx และเป็น local const
 * อีกตัวใน AddUserModal.tsx — หน้า profile จะเป็นที่ที่ 4 ถ้าไม่รวมมาไว้ที่เดียว
 * GoTrue เองตั้ง default ไว้แค่ 6 ตัว ตัวเลข 8 นี้จึงเป็นกฎของแอป ไม่ใช่ของ Supabase
 *
 * @module config/auth
 */

export const MIN_PASSWORD_LENGTH = 8;
